import { render } from "./Quizz.vue?vue&type=template&id=300864a0"
import script from "./Quizz.vue?vue&type=script&lang=js"
export * from "./Quizz.vue?vue&type=script&lang=js"
script.render = render

export default script